import { isDefined } from './helpers';

export default class ClbsCustomMulipleSelect
{
    constructor(node)
    {
        this.originalSelect = node || null;
        if(!isDefined(this.originalSelect)) console.error('Aucun noud n\'a été défini');
        this.node = null;
        this.buildCustomSelect();
    }

    init()
    {
        this.open();
        this.close();
        this.selectLabelForEvent();
        this.attacheChoiceEvents();
    }

    open()
    {
        const label = this.getLabel();
        label.addEventListener('click',  this.toggleChoices.bind(this));
    }

    close()
    {
        // retire la class clbs-custom-select__choices--open si on clique en dehors du select
        document.addEventListener('click',(e) => {
            if(!this.node.contains(e.target))
            {
                const choices = this.getChoices();
                if(choices.classList.contains('clbs-custom-select__choices--open'))
                {
                    choices.classList.remove('clbs-custom-select__choices--open');
                }
            }
        });
    }

    selectLabelForEvent()
    {
        const name = this.originalSelect.getAttribute('id');
        let label = document.querySelector("label[for='"+ name+"']");
        if(isDefined(label))
        {
            label.addEventListener('click', this.toggleChoices.bind(this));
        }
    }

    toggleChoices()
    {
        const choices = this.getChoices();
        choices.classList.toggle('clbs-custom-select__choices--open');
    }

    getLabel()
    {
        const label = this.node.querySelector('.clbs-custom-select__label');
        if(!isDefined(label)) console.error('Aucun label n\'a été défini');
        return label;
    }

    getChoices()
    {
        const choices = this.node.querySelector('.clbs-custom-select__choices');
        if(!isDefined(choices)) console.error('Aucun choix n\'a été défini');
        return choices;
    }

    attacheChoiceEvents()
    {
        const choices = this.getChoices();
        let selectValue = [];
        const self = this;
        choices.addEventListener('click', function(e){
            if(e.target && e.target.nodeName == "LI")
            {
                if(selectValue.indexOf(e.target.dataset.optionValue) == -1)
                {
                    e.target.classList.add('clbs-custom-select__choices__item--selected');
                    selectValue.push(e.target.dataset.optionValue);
                }
                else if (e.target.classList.contains('clbs-custom-select__choices__item--selected'))
                {
                    e.target.classList.remove('clbs-custom-select__choices__item--selected');
                    selectValue.splice(selectValue.indexOf(e.target.dataset.optionValue), 1);
                }
                self.updateOriginalSelect(selectValue);
                self.updateLabel(selectValue);
            }
        });
    }

    updateOriginalSelect(selected)
    {
        Array.from(this.originalSelect.options).forEach(function (option) {
            if (selected.includes(option.value)) {
                option.selected = true;
            } else {
                option.selected = false;
            }
        });
    }

    updateLabel(selected)
    {
        const label = this.getLabel();
        if(selected.length == 0)
        {
            label.innerHTML = 'Type de projet*';
        }
        else 
        {
            label.innerHTML = 'Vous avez sélectionné ' + selected.length + ' projet(s)';
        }
    }

    buildCustomSelect()
    {
        const wrapper = document.createElement('div');
        wrapper.classList.add('clbs-custom-select', 'js-clbs-custom-select-multiple');
        this.originalSelect.parentNode.insertBefore(wrapper, this.originalSelect);
        this.originalSelect.classList.remove('clbs-custom-select');
        this.originalSelect.classList.add('clbs-custom-select_original');
        this.originalSelect.setAttribute('hidden', true);
        if(this.originalSelect.getAttribute('multiple') == null)
        {
            this.originalSelect.setAttribute('multiple', true);
        }

        wrapper.appendChild(this.originalSelect);
        this.node = wrapper;

        const label = this.buildLabel();
        wrapper.appendChild(label);

        const choices = null;

        // Check si otpgroup
        if(this.originalSelect.querySelectorAll('optgroup').length > 0)
        {
            choices = this.buildChoicesWithOptGroup(this.originalSelect.querySelectorAll('optgroup'));
        }
        else
        {
            choices = this.buildChoices();
        }

        wrapper.appendChild(choices);

        this.init();
    }

    buildLabel()
    {
        let wrapper = document.createElement('div');
        wrapper.classList.add('custom-select-label', 'clbs-custom-select__label', 'custom-select');
        wrapper.innerHTML = 'Type de projet*';
        return wrapper;
    }

    buildChoices()
    {
        let wrapper = document.createElement('ul');
        wrapper.classList.add('custom-select-choices', 'clbs-custom-select__choices');
        let options = Array.from(this.originalSelect.options);
        if(options.length > 0)
        {
            options.forEach(option => {
                let li = document.createElement('li');
                li.setAttribute('data-option-value', option.value);
                li.innerHTML = option.innerHTML;
                wrapper.appendChild(li);
            });
        }
        return wrapper;
    }

    buildChoicesWithOptGroup(groups)
    {
        // Creer un ul pour chaque groups
        let wrapper = document.createElement('div');
        wrapper.classList.add('custom-select-choices', 'clbs-custom-select__choices');
        let subwrapper = document.createElement('div');
        subwrapper.classList.add('clbs-custom-select-group');
        wrapper.appendChild(subwrapper);
        groups.forEach(group => {
            let title = group.label;
            let ul = document.createElement('ul');
            ul.classList.add('clbs-custom-select-group__list');
            let li = document.createElement('li');
            li.classList.add('clbs-custom-select-group__title');
            li.innerHTML = group.label;
            ul.appendChild(li);
            let options = Array.from(group.querySelectorAll('option'));
            options.forEach(option => {
                let li = document.createElement('li');
                li.setAttribute('data-option-value', option.value);
                li.innerHTML = option.innerHTML;
                ul.appendChild(li);
            });
            subwrapper.appendChild(ul);
        });
        return wrapper;
    }
}